var exports = {
  "Q": "x2b2fbebb--2ab466--content",
  "P": "x2b2fbebb--2ab466--border",
};

module.exports = exports;
